import { DiagnosisRow } from "../../api/diagnosis.type";
import MedicalRecordSummaryCard from "../medical-records/medical-record-summary-card";
import { formatTimeStampToHumanReadableDate } from "../utls/time";
import { pickRecordValue } from "#/lib/medicalRecords";

type DiagnosisSummaryCardProps = {
  diagnosis: DiagnosisRow;
  onClick?: () => void;
};

const statusToneMap: Record<string, "default" | "success" | "warning"> = {
  active: "success",
  resolved: "default",
  pending: "warning",
};

const formatDate = (value?: string | null) => {
  if (!value || value === "infinity") return undefined;
  try {
    return formatTimeStampToHumanReadableDate(value);
  } catch {
    return undefined;
  }
};

export function DiagnosisSummaryCard({ diagnosis, onClick }: DiagnosisSummaryCardProps) {
  const title =
    pickRecordValue<string>(diagnosis as any, ["name", "diagnosis_description"]) ||
    "Diagnosis";
  const subtitle = pickRecordValue<string>(diagnosis as any, [
    "diagnosis_code",
    "diagnosisCode",
  ]);
  const statusRaw = pickRecordValue<string>(diagnosis as any, ["status"]);

  const meta = [
    {
      label: "Effective",
      value:
        formatDate(
          pickRecordValue<string>(diagnosis as any, [
            "effective_from",
            "effectiveFrom",
          ])
        ) ?? formatDate(pickRecordValue(diagnosis as any, ["created_at", "createdAt"])),
    },
    {
      label: "Last updated",
      value: formatDate(pickRecordValue(diagnosis as any, ["updated_at", "updatedAt"])),
    },
  ];

  return (
    <MedicalRecordSummaryCard
      title={title}
      subtitle={subtitle}
      status={statusRaw}
      statusTone={statusRaw ? statusToneMap[statusRaw.toLowerCase()] ?? "default" : "default"}
      meta={meta}
      onClick={onClick}
    />
  );
}

export default DiagnosisSummaryCard;
